import React from "react";
import TrainingContentList from "./TrainingContentList";

const FMSTraining = () => {
  return (
    <TrainingContentList
      category="fms-training"
      title="FMS Training"
      breadcrumbs={["Training Library", "FMS Training"]}
    />
  );
};

export default FMSTraining;
